// #region CONSTANTS
export const ACTIONS = {
  count: 'count',
  find: 'find',
  insert: 'insert',
  update: 'update',
  upsert: 'upsert',
};

// Injected at build time by webpack DefinePlugin (from .env).
export const API_KEY = process.env.ATLAS_API_KEY;

export const HEADERS = {
  'Content-Type': 'application/json',
  'x-api-key': API_KEY,
};

export const VERSION = {
  1: 'v1',
  2: 'v2',
};

const URL_DEV = process.env.ATLAS_URL_DEV;
const URL_PROD = process.env.ATLAS_URL_PROD;

/**
 * @param {string} mode [production || dev]
 * @param {string} version API version string
 * @returns {string} url to fetch (URL_DEV | URL_PROD)
 */
export const getUrl = (mode, version) => {
  let url = `${URL_DEV}/${version}`;
  if (mode === 'production') {
    url = `${URL_PROD}/${version}`;
  }

  return url;
};

export const STATUS_OK = 200;
export const STATUS_NO_DATA = 204;
// #endregion
